<template>
  <div class="disciplinaryMeasure">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <employee-sidebar v-if="currentUser.employee.designation.departmentId === 14">
      </employee-sidebar>
      <layout-sidebar v-else></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Training Plans</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Training Plans</li>
                </ul>
              </div>
              <div class="col-md-4 float-right ml-auto">
                <fieldset class="borderFieldset">
                  <legend>Export</legend>
                  <div class="row">
                    <div class="col-md-6">
                      <select v-model="year" class="form-control">
                        <option v-for="y in Years" :key="y" :value="y">
                          {{ y }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <a @click="exportPlan" class="btn btn-primary"> Export</a>
                      <a @click="openImport" class="btn add-btn"
                        ><i class="fa fa-plus"></i> Import Plan</a
                      >
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="trainingPlans"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <a class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.trainingNeed.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="
                            media + item.trainingNeed.employee.passportPhoto
                          "
                          width="38"
                          v-if="item.trainingNeed.employee.passportPhoto"
                      /></a>
                      <a
                        >{{
                          `${item.trainingNeed.employee.firstName} ${item.trainingNeed.employee.lastName}`
                        }}
                      </a>
                    </h2>
                  </template>
                  <template v-slot:[`item.startDate`]="{ item }">
                    {{ new Date(item.startDate).toLocaleDateString() }}
                  </template>
                  <template v-slot:[`item.endDate`]="{ item }">
                    {{ new Date(item.endDate).toLocaleDateString() }}
                  </template>
                  <template v-slot:[`item.desig`]="{ item }">
                    <span>{{
                      item.trainingNeed.employee.designation.name
                    }}</span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click="setEditPlan(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" @click="setDeletePlan(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add training plan Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Training Plan</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="form-group">
                  <label>Employee <span class="text-danger">*</span></label>
                  <input
                    :value="
                      plan.trainingNeed.employee.firstName +
                        ' ' +
                        plan.trainingNeed.employee.lastName
                    "
                    id="vendor"
                    name="vendor"
                    class="form-control"
                    type="text"
                    disabled
                  />
                </div>
                <div class="form-group">
                  <label>Programme <span class="text-danger">*</span></label>
                  <input
                    :value="plan.trainingNeed.trainingProgramme.programme"
                    id="vendor"
                    name="vendor"
                    class="form-control"
                    type="text"
                    disabled
                  />
                </div>
                <div class="form-group">
                  <label>Provider <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="plan.trainingProviderId"
                  >
                    <option>Select Provider</option>
                    <option
                      v-for="member in providers"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.vendor }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Transport <span class="text-danger">*</span></label>
                  <input
                    v-model="plan.transport"
                    id="program"
                    name="program"
                    class="form-control"
                    type="number"
                  />
                </div>
                <div class="form-group">
                  <label>DSA <span class="text-danger">*</span></label>
                  <input
                    v-model="plan.dsa"
                    id="program"
                    name="program"
                    class="form-control"
                    type="number"
                  />
                </div>
                <div class="form-group">
                  <label>Start Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="plan.startDate"
                      bootstrap-styling
                      class="datetimepicker"
                      type="date"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>End Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="plan.endDate"
                      bootstrap-styling
                      class="datetimepicker"
                      type="date"
                    />
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onPutSubmit"
                    data-dismiss="modal"
                    class="btn btn-primary submit-btn"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add disciplinaryCase Modal -->
        <!-- Delete training needs Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Training Plan</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="onDeleteSubmit"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete disciplinaryCase Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Plan</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Plan</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row) in first sheet only. <br />
                    Regards <strong>TrainingNeed Number</strong> and
                    <strong>TrainingProvider Number</strong> columns you are
                    expected to get the value from their representing sheet.
                    <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importPlan"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import EmployeeSidebar from "@/components/layouts/employeeSidebar.vue"
import { required, sameAs } from "vuelidate/lib/validators";
import { trainingService } from "@/services/trainingService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    EmployeeSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "Designation", value: "desig" },
        {
          text: "Skill Gap",
          value: "trainingNeed.trainingProgramme.skillGap.name"
        },
        { text: "Program", value: "trainingNeed.trainingProgramme.programme" },
        { text: "Start Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
        { text: "Tuition Fee", value: "trainingProvider.tuitionFee" },
        { text: "Transport", value: "transport" },
        { text: "DSA", value: "dsa" },
        { text: "Total", value: "total" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      trainingProviderId: 0,
      transport: "0",
      dsa: "0",
      year: new Date().getFullYear(),
      plan: {
        trainingNeed: {
          employee: {},
          trainingProgramme: {}
        }
      },
      loading: false,
      error: "",
      Years: [],
      providers: [],
      trainingPlans: [],
      submitted: false,
      currentUser: authenticationService.currentUserValue,
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      file: null,
      fileName: ""
    };
  },

  validations: {
    skillGap: { required },
    program: { required }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  methods: {
    getProviders() {
      trainingService
        .getTrainingProvidersByProgramme(
          this.plan.trainingNeed.trainingProgrammeId
        )
        .then(
          model => {
            this.providers = model;
          },
          error => {
            error = error;
          }
        );
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    getPlans() {
      trainingService.getCurrentTrainingPlan(this.company.id).then(r => {
        this.trainingPlans = r;
        console.log(r);
      });
    },
    openDialog() {
      this.dialog = true;
    },
    openImport() {
      this.dialogImport = true;
    },
    close() {
      this.clearList();
      this.dialog = false;
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeStatus() {
      this.dialogStatus = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    clearList() {
      this.employeeId = "";
      this.need.id = "";
      this.trainingProviderId = "";
      this.transport = "";
      this.dsa = "";
      this.submitted = false;
    },
    setEditPlan(model) {
      this.plan = model;
      this.getProviders();
      this.dialogEdit = true;
    },
    setDeletePlan(model) {
      this.plan = model;
      this.dialogDelete = true;
    },
    onDeleteSubmit() {
      const id = this.plan.id;
      trainingService.removePlan(id).then(id => {
        trainingService.getCurrentTrainingPlan(this.company.id).then(r => {
          this.trainingPlans = r;
          this.closeDelete();
        });
      });
    },
    importPlan() {
      trainingService.importPlan(this.company.id, this.file).then(id => {
        trainingService.getCurrentTrainingPlan(this.company.id).then(r => {
          this.providers = r;
          this.closeImport();
        });
      });
    },
    downloadTemplate() {
      trainingService.downloadPlanTemplate(this.company.id).then(
        response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        error => {
          this.error = error;
        }
      );
    },

    onSubmit() {
      this.submitted = true;

      this.loading = true;
      var req = {
        trainingNeedId: this.need.id,
        trainingProviderId: this.trainingProviderId,
        transport: this.transport,
        dsa: this.dsa
      };
      trainingService.addPlan(req).then(
        id => {
          this.message = "Training Plan created successfully";
          trainingService.getCurrentTrainingPlan(this.company.id).then(r => {
            this.trainingPlans = r;
            this.close();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    onPutSubmit() {
      this.loading = true;
      trainingService.editPlan(this.plan).then(
        id => {
          this.message = "Training Plan updated successfully";
          trainingService.getCurrentTrainingPlan(this.company.id).then(r => {
            this.trainingPlans = r;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    generateYears() {
      var currentYear = new Date().getFullYear();
      var finalYear = currentYear - 10;

      for (var i = currentYear; i > finalYear; i--) this.Years.push(i);
    },
    exportPlan() {
      trainingService.exportPlan(this.company.id, this.year).then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    }
  },

  mounted() {
    this.generateYears();
    this.getPlans();

    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeedisciplinaryMeasures(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    $(document).on("change", "#customleave_select", function() {
      //$(this).find('option:selected')
      return false;
    });
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "trainingNeeds"
};
</script>



// WEBPACK FOOTER //
// src/components/training/trainingPlan.vue